import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';
import { ObjectUtil } from '../../../components/common/object-util/object-util';

/**
 * Valuation Evet properties service
 */
@Injectable({
  providedIn: 'root'
})
export class ValuationEventPropertiesService {
  /**
   * The properties resource URL
   */
  private _propertiesResource: string;

  /**
   * Constructor
   * @param httpClient
   * @param appServiceHelper
   */
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
    this._propertiesResource = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', 'Properties');
  }

  /**
   * Load properties for a valuation event
   * @param valuationEventId
   * @param projectId
   * @returns
   */
  loadPropertiesForValuationEvent(valuationEventId: number, projectId: number): Observable<any> {
    return this.httpClient.get<any>(`${this._propertiesResource}/getPortfolioProperties/?valuationEventId=${valuationEventId}&projectId=${projectId}`);
  }

  /**
   * Assign or unassign a property to a portfolio
   * @param assign
   * @param propertyId
   * @param portfolioId
   * @param projectId
   * @returns
   */
  assignToPortfolio(assign: boolean, propertyId: number, portfolioId: number, projectId: number) {
    // assign: positive portfolio, unassign: negative portfolio
    const query = `portfolioId=${(assign ? portfolioId : -portfolioId)}&projectId=${projectId}&propertyId=${propertyId}`;

    return this.httpClient.post<any>(`${this._propertiesResource}/setPortfolioId?${query}`, {});
  }

  /**
   * Load a paged list
   * @param take
   * @param skip
   * @param page
   * @param pageSize
   * @param filter
   * @returns
   */
  loadPagedList(take: number, skip: number, page: number, pageSize: number, filter: any) {

    const query = `?take=${take}&skip=${skip}&page=${page}&pageSize=${pageSize}${this.applyFilter(filter)}`;
    return this.httpClient.get<any>(`${this._propertiesResource}/list/paged${query}`);
  }

  /**
   * Apply a filter
   * @param filter
   * @returns
   */
  applyFilter(filter: any) {

    const hasCustomFilter: boolean = filter?.filters?.length > 0;
    let filterQueryString = '';
    if (hasCustomFilter) {
      const filterCopy = ObjectUtil.deepCopy(filter);
      filterCopy.useV2ServerFilter = true;
      filterQueryString = `&filter=${encodeURIComponent(JSON.stringify(filterCopy))}`;
    }

    return filterQueryString;

  }
}
